import React from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import * as S from './Header.styles';

import IconSelector from '@ibibo/icon-selector';
import * as actions from '../../../store/actions/index';
import {sendEvarData} from '@ibibo/analytics';

import {HOME_PAGE_URL, LOGIN_PAGE_URL} from '../../../constants';

const HeaderPartner = ({step, userType}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const stepMap = {
    1: 'personalDetails',
    2: 'OTPVerification',
  };
  const toLogin = () => {
    sendEvarData(
      {
        prop54: `myPartner|signup|${stepMap[step]}|login`,
      },
      true,
    );

    history.push(LOGIN_PAGE_URL);
  };

  const toRegister = () => {
    sendEvarData(
      {
        prop54: 'myPartner|login|OTP|signUp',
      },
      true,
    );
    dispatch(actions.resetInitialData());
    history.push(HOME_PAGE_URL);
  };

  let userOption = null;
  switch (userType) {
    case 'preRegister':
      userOption;
      break;
    case 'onboarding':
      userOption = (
        <S.LoginWrapper>
          <S.MemberText>Already a member?</S.MemberText>
          <S.MemberLoginWrapper>
            <IconSelector iconKey="mylogin" />
            <S.MemberLoginText onClick={toLogin}>Login</S.MemberLoginText>
          </S.MemberLoginWrapper>
        </S.LoginWrapper>
      );
      break;
    case 'login':
      userOption = (
        <S.LoginWrapper>
          <S.MemberText>New Here?</S.MemberText>
          <S.MemberLoginWrapper>
            <IconSelector iconKey="mylogin" />
            <S.MemberLoginText onClick={toRegister}>SIGN UP</S.MemberLoginText>
          </S.MemberLoginWrapper>
        </S.LoginWrapper>
      );
      break;
  }

  return (
    <S.HeaderOuterWrap>
      <S.LogoWrapper>
        <IconSelector iconKey="partnerlogo" />
        <S.TitleText>
          <h3>The Smart Way to Grow Your Business</h3>
        </S.TitleText>
      </S.LogoWrapper>
      {userOption}
    </S.HeaderOuterWrap>
  );
};

export default HeaderPartner;
